import * as React from 'react';
import { ActionButton, ComboBox, DefaultButton, getTheme, Panel, PrimaryButton, Stack, TextField, Text, Label } from '@fluentui/react';

interface IFolderPropertiosView {
    parentId?: number;
    id: number | undefined;
    name: string;
    onDismiss: () => void;
    save: (id: number | undefined, name:string, parentId: number | undefined ) => void;    
}

export const FolderPropertiosView: React.FC<IFolderPropertiosView> = props => {
    const [name, setName] = React.useState<string>(props.name);
    const theme = getTheme();

    return (<Panel title="Vložení obrázku"
        onDismiss={props.onDismiss}
        isOpen={true}
    >
        <Stack tokens={{ childrenGap: 10 }} >
        <TextField label="Název složky" value={name} onChange={(e, value) => setName(value ? value : "")} ></TextField>
        <Stack tokens={{ childrenGap: 10 }} horizontal horizontalAlign="center">
            <PrimaryButton text="Uložit" onClick={() => props.save(props.id, name, props.parentId)} />
            <DefaultButton text="Zavři" onClick={props.onDismiss} />
            </Stack>
        </Stack>
    </Panel>)
}
 